import React from 'react'
import { useIntl } from 'react-intl'
import {
  Modal,
  ModalBody,
  ModalFooter
} from '@contrast-security-inc/design-system-popovers'
import { IconHelp } from '@contrast-security-inc/design-system-foundations'
import { Text } from '@contrast-security-inc/design-system-typography'
import { DiagnosticCollectionFormValue } from '../index'
import { DiagnosticCollectionButtonStop } from './diagnostic-collection-button-stop'
import { CancelButton } from './cancel-button'

export function DiagnosticCollectionStopModal({
  onClick,
  onCancel,
  formValue,
  visible
}: {
  onClick: (value: DiagnosticCollectionFormValue) => void
  onCancel: () => void
  formValue: DiagnosticCollectionFormValue
  visible: boolean
}) {
  const { formatMessage } = useIntl()

  return (
    <Modal
      size="md"
      title={formatMessage({ id: 'action_diagnostic_disable' })}
      variant="warning"
      onClose={() => onClick(formValue)}
      isOpen={visible}
      Icon={IconHelp}
    >
      <ModalBody>
        <Text font="body">
          {formatMessage({ id: 'detail_servers_stopDiagnostics_confirm' })}
        </Text>
      </ModalBody>
      <ModalFooter>
        <CancelButton onClick={onCancel} />
        <DiagnosticCollectionButtonStop
          onClick={onClick}
          formValue={formValue}
        />
      </ModalFooter>
    </Modal>
  )
}
